import {} from "../constant";
import axios from 'axios';
import * as REPO from '../helper/main'
import {URL_LOGIN_MW} from "../constant";
import {MW_GET_LAST_POSITION} from "../constant";

const localKey = 'token';


export const loginMW = () => {
    let config_token = {
        headers: {}
    };
    let login_param =
        {
            grant_type: 'password',
            client_id: '1',
            client_secret: 'f0DR3Tp9Unxo3NPSKLdPEVeRciwXsMPY8Ofa3GtF',
            username: 'astrafms_lastposition@sera.astra.co.id',
            password: '4sTr4Fm5!!',
            scope: 'backend message-stream'
        };
    return axios.post(URL_LOGIN_MW, login_param, config_token);
};


export const getOneLastPosition = (data, token) => {
    let config_token = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };

    return axios.get(MW_GET_LAST_POSITION + "?imei=" + data, config_token);
};

